import { render, staticRenderFns } from "./voiddetail.vue?vue&type=template&id=2dcaa13a&scoped=true&"
import script from "./voiddetail.vue?vue&type=script&lang=js&"
export * from "./voiddetail.vue?vue&type=script&lang=js&"
import style0 from "./voiddetail.vue?vue&type=style&index=0&id=2dcaa13a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcaa13a",
  null
  
)

export default component.exports